const ByDeviceOS = ({ deviceOS, totalLeads }) => {
    return (
        <div>
            <div className="card mb-2">
                <div className="align-items-center p-2 card-header">
                    <div className="font-weight-bold float-left">Device Operating Systems</div>
                </div>
                <div className="card-body p-2">
                    <table className="table table-card table-borderless table-striped table-hover">
                        <thead className="border-bottom">
                            <tr>
                                <th scope="col">Device OS</th>
                                <th scope="col" className="text-right">
                                    Lead %
                                </th>
                                <th scope="col" className="text-right">
                                    Lead Count
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {deviceOS.length === 0 ? (
                                <tr>
                                    <td colSpan={3}>No stats available</td>
                                </tr>
                            ) : (
                                deviceOS.map((item) => (
                                    <tr key={item.device_os}>
                                        <td>{item.device_os}</td>
                                        <td align="right">{totalLeads > 0 ? Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((item.lead_count / totalLeads) * 100) : 0}%</td>
                                        <td align="right">{item.lead_count}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ByDeviceOS
